import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import '../styles/header.scss';

const useOutsideClick = (ref, setShowLangs) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowLangs(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}
const Header = () => {
    const { t, i18n } = useTranslation();
    const [currentLang, setCurrentLang] = useState(i18n.resolvedLanguage);
    const [showLangs, setShowLangs] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const handleLangChange = (e) =>{
        setShowLangs(false);
        setShowMenu(false);
        const lang = e.currentTarget.dataset.lang;
        i18n.changeLanguage(lang);        
        setCurrentLang(lang);
    }

    const toggleMenu = (e) => {
        e.preventDefault();
        setShowMenu(!showMenu);
    }

    const wrapperRef = useRef(null);
    useOutsideClick(wrapperRef, setShowLangs);

    return (
        <header id="header" >
            <div className="container">
                <div className="navbar">
                    <a href="#main">
                        <span className="navbar-brand">
                            <i></i>
                        </span>
                    </a>
                    <div className={`collapseBtn ${showMenu ? 'active' : ''}`} onClick={toggleMenu}>
                        <i></i>
                    </div>
                    <ul className="nav">
                        <li className="nav-item">
                            <a className="nav-link" href="#services">{t("header.services")}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#about">{t("header.about")}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#partners">{t("header.partners")}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#projects">{t("header.projects")}</a>
                        </li>
                    </ul>
                    <div className="btns">
                        <a className="btn btn-outline" href="#application">{t("header.application.btn")}</a>
                        <div className={`dropdown ${showLangs ? 'active': ''}`} >
                            <a className="dropbtn" onClick={(e)=>{e.preventDefault(); setShowLangs(!showLangs)}}>{currentLang}</a>
                            <ul className="dropcontent" >
                                {currentLang !== 'ru' && (<li onClick={handleLangChange} data-lang="ru">RU</li>)}
                                {currentLang !== 'en' && (<li onClick={handleLangChange} data-lang="en">EN</li>)}
                                {currentLang !== 'kz' && (<li onClick={handleLangChange} data-lang="kz">KZ</li>)}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`collapseContent ${showMenu ? 'active' : ''}`}>
                <div className="container">
                    <ul className="nav">
                        <li className="nav-item">
                            <a className="nav-link" onClick={(e)=>{setShowMenu(false)}} href="#services">{t("header.services")}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" onClick={(e)=>{setShowMenu(false)}} href="#about">{t("header.about")}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" onClick={(e)=>{setShowMenu(false)}} href="#projects">{t("header.projects")}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" onClick={(e)=>{setShowMenu(false)}} href="#partners">{t("header.partners")}</a>
                        </li>
                    </ul>
                    <div className="btns">
                        <a className="btn btn-outline" onClick={(e)=>{setShowMenu(false)}} href="#application">{t("header.application.btn")}</a>
                        <div className={`dropdown ${showLangs ? 'active': ''}`} >
                            <a className="dropbtn" onClick={(e)=>{e.preventDefault(); setShowLangs(!showLangs)}}>{currentLang}</a>
                            <ul className="dropcontent">
                                {currentLang !== 'ru' && (<li onClick={handleLangChange} data-lang="ru">RU</li>)}
                                {currentLang !== 'en' && (<li onClick={handleLangChange} data-lang="en">EN</li>)}
                                {currentLang !== 'kz' && (<li onClick={handleLangChange} data-lang="kz">KZ</li>)}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
} ;

export default Header;